import { useAppSelector } from 'store/hooks';
import { DatePicker } from './date-picker.reducer';

export const useDatePickerSelector = (datePickerId: string): DatePicker =>
  useAppSelector(({ datePicker }) => datePicker[datePickerId]);

export const useCheckCalendarTabEqual = (ids: string[]): boolean =>
  useAppSelector(({ datePicker }) =>
    ids.every(
      (id) => datePicker[id].calendarTab === datePicker[ids[0]].calendarTab,
    ),
  );
